import script from "./TitleRelatedTitlesSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleRelatedTitlesSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./TitleRelatedTitlesSkeleton.vue?vue&type=style&index=0&id=23c5afc6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c5afc6"]])

export default __exports__